import { instance } from "libs/api";

import { ApiRoutesCoupons } from "../../constants";
import { CreateCouponBody } from "./createCoupon.types";

export const requestCreateCoupon = async (
  body: CreateCouponBody
): Promise<void> => {
  return await instance.post(ApiRoutesCoupons.Coupons, body);
};
